<template>
  <div class="rule">
    <a-button
      type="primary"
      icon="plus"
      style="margin-bottom:20px"
      @click="
        visible = true;
        action = 'add';
      "
      >添加规则</a-button
    >
    <a-table
      :columns="columns"
      :data-source="curAlarmData"
      rowKey="id"
      bordered
      size="middle"
      :rowClassName="rowClassName"
      :pagination="{
        current: page,
        total: total,
        pageSize: size,
        onChange: onPageChange
      }"
    >
      <span slot="index" slot-scope="text, record, index">
        {{ (page - 1) * size + index + 1 }}
      </span>
      <span slot="param" slot-scope="text">
        {{ typesFormatter(text) }}
      </span>
      <span slot="send_alarm" slot-scope="text">
        <a-switch :checked="text" disabled />
      </span>
      <span slot="operation" slot-scope="row">
        <a-popconfirm
          :title="'确认要' + (row.enable ? '关闭' : '开启') + '么？'"
          ok-text="是"
          cancel-text="否"
          @confirm="isOpenCurAlarmRule(row)"
          @cancel="
            () => {
              $message.error('取消' + (row.enable ? '关闭' : '开启'));
            }
          "
        >
          <a style="color: #1890ff">{{ row.enable ? "关闭" : "开启" }}</a>
        </a-popconfirm>
        <a-divider type="vertical" />
        <a style="color: #1890ff" @click="updateCurAlarmRule(row)">修改</a>
        <a-divider type="vertical" />
        <a-popconfirm
          title="确认要删除么？"
          ok-text="是"
          cancel-text="否"
          @confirm="deleteCurAlarmRule(row.id)"
          @cancel="
            () => {
              $message.error('取消删除');
            }
          "
        >
          <a style="color: #1890ff">删除 </a>
        </a-popconfirm>
      </span>
    </a-table>
    <add-or-edit-rule
      :action="action"
      :visible.sync="visible"
      :record="record"
      @onOk="
        v => {
          visible = v;
          getCurAlarmList();
        }
      "
      ref="add_edit_rule"
    ></add-or-edit-rule>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import { getAlarmList, deleteAlarmRule, updateAlarmRule } from "@/api/api";
import AddOrEditRule from "./components/AddOrEditRule";
import { alarm_rule_columns } from "@/options/columns";

export default {
  data() {
    return {
      columns: alarm_rule_columns,
      curAlarmData: [],
      page: 1,
      size: 10,
      total: 0,
      action: "",
      visible: false,
      record: {}
    };
  },
  components: {
    AddOrEditRule
  },
  computed: {
    ...mapState(["authUserInfo", "sensortypes"]),
    ...mapGetters(["defaultInfo"])
  },
  mounted() {
    this.getStationList();
    this.getCurAlarmList();
  },
  methods: {
    ...mapActions(["getStationList"]),
    typesFormatter(value) {
      let type = this.sensortypes.find(item => item.value == value);
      return type?.name || "";
    },
    async getCurAlarmList() {
      try {
        let res = await getAlarmList(
          this.defaultInfo.defaultGroupId,
          this.page,
          this.size
        );
        this.curAlarmData = res.data.items;
        this.page = res.data.page;
        this.total = res.data.total;
      } catch (error) {
        console.log(error);
      }
    },
    updateCurAlarmRule(row) {
      this.record = row;
      this.visible = true;
      this.action = "edit";
    },
    async deleteCurAlarmRule(id) {
      try {
        let res = await deleteAlarmRule(id);
        await this.getCurAlarmList();
        this.$message.success(res.data.msg);
      } catch (error) {
        console.log(error);
      }
    },
    async isOpenCurAlarmRule(row) {
      let enable = !row.enable ? true : false;
      const params = {
        id: row.id,
        param: row.param,
        station_name: row.station_name,
        max_threshold: row.max_threshold,
        min_threshold: row.min_threshold,
        td: row.td,
        enable: enable,
        send_alarm: row.send_alarm,
        webhook_id: row.webhook_id,
        webhook_id_push: row.webhook_id_push
      };
      try {
        let res = await updateAlarmRule(params);
        await this.getCurAlarmList();
        this.$message.success(res.data.msg);
      } catch (error) {
        console.log(error);
      }
    },
    onPageChange(v) {
      this.page = v;
      this.getCurAlarmList();
    },
    rowClassName(record, index) {
      if (index % 2 === 0) {
        return "even-tr";
      } else {
        return "odd-tr";
      }
    }
  }
};
</script>

<style lang="less" scoped>
.rule {
  background: white;
  margin: 10px;
}

/deep/ .odd-tr {
  background: #fafafa;
}
</style>
